module.exports = __webpack_public_path__ + "img/st.1f545eb9.svg";